export const DIGITAL_LOCATION = "DIGITAL_LOCATION";

export const ADDRESS = {
  // Address fields
  ADDRESS_1: "address1",
  ADDRESS_1_ERROR: "address1Error",
  ADDRESS_1_ERROR_MSG: "address1ErrorMsg",
  ADDRESS_2: "address2",
  ADDRESS_2_ERROR: "address2Error",
  ADDRESS_2_ERROR_MSG: "address2ErrorMsg",
  ADDRESS_3: "address3",
  ADDRESS_LINE_2: "addressLine2",
  ADDRESS_TYPE: "addressType",
  ZIP_CODE: "addressLine2",
  POSTAL_CODE: "postalCode",
  POSTALCODE_EXT: "postalCodeExt",
  CITY: "city",
  CITY_ERROR: "cityError",
  CITY_ERROR_MSG: "cityErrorMsg",
  COUNTRY_GEO_ID: "countryGeoId",
  LANDMARK: "landmark",
  HOUSE_NO: "houseNo",
  DOORBELL: "doorBellName",
  DOORBELL_ERROR: "doorBellError",
  DOORBELL_ERROR_MSG: "doorBellErrorMsg",
  LATITUDE: "latitude",
  LONGITUDE: "longitude",

  // Contact fields
  TO_NAME: "toName",
  TO_NAME_ERROR: "toNameError",
  TO_NAME_ERROR_MSG: "toNameErrorMsg",
  MOBILE_NUMBER: "mobileNumber",
  MOBILE_NUMBER_ERROR: "mobileNumberError",
  MOBILE_NUMBER_ERROR_MSG: "mobileNumberErrorMsg",
  TELE_CODE: "teleCode",
  ALT_RECP_NUMBER: "altRecpNumber",
  ALT_RECP_TELE_CODE: "altRecpTeleCode",
  EMAIL: "email",
  EMAIL_ERROR: "emailError",
  EMAIL_ERROR_MSG: "emailErrorMsg",

  // Form modes (selectedContactMechId)
  EDIT_ADDRESS: "editaddress",
  NEW_ADDRESS: "newaddress",

  // Map form, sent to update-address-rj
  ACCURACY: "accuracy",
  ACCURACY_TYPE: "accuracyType",
  PLACE_ID: "placeId",

  // Map form UI state (not saved)
  LOCALITY_TITLE: "localityTitle",
  LOCALITY_TYPES: "localityTypes",
  MAP_FOCUS_PLACE: "mapFocusPlace",
  MAP_FOCUS_COORDINATES: "mapFocusCoordinates",
  MAP_SEARCH_REQUEST: "mapSearchRequest",
  IS_LOCALITY_SEARCH_ACTIVE: "isLocalitySearchActive",
  INITIAL_PIN_LAT: "initialPinLat",
  INITIAL_PIN_LONG: "initialPinLong",
  SUGGESTED_POSTAL_CODE: "suggestedPostalCode",
  SUGGESTED_CITY: "suggestedCity",

  // Map form: address validation API result (not saved)
  VALIDATED_PINCODE: "validatedPincode",
  VALIDATED_CITY: "validatedCity",
  VALIDATED_LAT: "validatedLat",
  VALIDATED_LONG: "validatedLong",
  PINCODE_WARNING_TEXT: "pincodeWarningText",
  IS_SAVE_ADDRESS_DISABLED: "isSaveAddressDisabled",
  IS_ADDRESS_VALIDATING: "isAddressValidating",
  // Map form: web_feature_control "ableToAddAddressFreely" for the starting location, and a typed (not picked) locality
  IS_FREE_LOCALITY_ALLOWED: "isFreeLocalityAllowed",
  IS_FREE_LOCALITY_ENTERED: "isFreeLocalityEntered",
  // Map form visit facts for address save events. Not sent to update-address-rj.
  LOCATION_TRACKING: "locationTracking",
};

export const deliveryAddressTypes = {
  OFFICE: "office",
};

export const adrressType = [
  { name: "Home", value: "home" },
  { name: "Office", value: deliveryAddressTypes.OFFICE },
  { name: "Other", value: "other" },
];

export const specialCountries = ["USA", "CAN", "GBR", "IRL"];
export const excludePincodeCountries = ["ARE", "HKG", "OMN", "QAT", "LBN"];
